import clsx from 'clsx';

import { CourseCard } from './CourseCard';
import { useCourses } from './useCourses';
import { useAppContext, useLocalize } from '../../hooks';
import { Empty, GridList, Loading, Tabs } from '../../components';

const CoursesPage = () => {
  const { t } = useLocalize();
  const { isMobile } = useAppContext();
  const { loading, courses } = useCourses();

  if (loading) return <Loading />;
  if (!courses.length) {
    return (
      <div className="w-full mx-sm">
        <div className="flex flex-col justify-center items-center h-full">
          <Empty message={t('courses.page.nocourses')} />
        </div>
      </div>
    );
  }

  return (
    <div className="w-full px-[2rem] overflow-y-auto">
      <div
        className={clsx(
          'mx-auto',
          isMobile
            ? 'sm:max-w-screen-sm md:max-w-screen-md'
            : 'sm:max-w-screen-sm md:max-w-screen-md xl:max-w-screen-xl'
        )}
      >
        <div className="flex flex-col items-center pt-[4rem] sm:pt-[8rem] pb-lg">
          <div className="text-[2.8rem] leading-[3.2rem] sm:text-[3.2rem] sm:leading-[3.8rem] font-semibold sm:text-center text-left">
            {t('courses.page.title')}
          </div>
        </div>

        <Tabs
          activeTab="All courses"
          className="mb-xl w-full text-main"
          tabsClassName="border-tabBackground"
          tabClassName="border-main border-b-4 font-[600] py-0 px-0"
          tabs={[{ name: 'All courses', label: t('courses.page.allcourses') }]}
        />
        <div className="flex justify-center">
          <GridList
            items={courses}
            gap="gap-14"
            className={clsx(
              isMobile
                ? 'grid-cols-1'
                : 'sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
            )}
            renderItem={(item, index) => (
              <div key={index}>
                <CourseCard item={item} />
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default CoursesPage;
